export const CENTER = {
  name: "Blessed Beginnings Learning Center",
  tagline: "A 24-Hour Home Learning Center",
  address: "8748 Balboa Drive, Cincinnati, Ohio 45231",
  phones: ["513-394-0360", "513-218-2638"],
  email: "admin@blessedbeginningslearningcenter.org",
};

export const IMAGES = {
  heroMain:
    "https://images.unsplash.com/photo-1578349035260-9f3d4042f1f7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  heroSmall1:
    "https://images.unsplash.com/photo-1560130958-0ea787c275de?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  heroSmall2:
    "https://images.unsplash.com/photo-1557452765-5b57d100c1dc?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  about:
    "https://images.unsplash.com/photo-1587323655395-b1c77a12c89a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  healthyFood:
    "https://images.unsplash.com/photo-1606787620114-e44702d1b7bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
};

export const GALLERY = [
  {
    url: "https://images.unsplash.com/photo-1533222481259-ce20eda1e20b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Joyful child of diverse background laughing outdoors",
  },
  {
    url: "https://images.pexels.com/photos/3992949/pexels-photo-3992949.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Diverse group of children focused on learning activities together",
  },
  {
    url: "https://images.unsplash.com/photo-1533222535026-754c501569dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Children of many backgrounds playing together on a grassy field",
  },
  {
    url: "https://images.unsplash.com/photo-1627764940620-90393d0e8c34?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Multicultural children holding hands in a circle",
  },
  {
    url: "https://images.unsplash.com/photo-1701834951900-b31c99da66f8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "A diverse group of happy kids sitting together",
  },
  {
    url: "https://images.unsplash.com/photo-1587323655395-b1c77a12c89a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Caregiver and child coloring together",
  },
];
